"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTransactionPayload = exports.sendSignedData = exports.getAllTransactions = exports.getLatestBlock = exports.setConfiguration = exports.exportSeed = exports.getPublicKey = exports.getAddress = exports.getBalance = exports.signPayloadRaw = exports.signPayloadJSON = void 0;
function sendSnapMethod(request, snapId) {
    return __awaiter(this, void 0, void 0, function* () {
        console.info('sendSnapMethod', request, snapId);
        return yield window.ethereum.request({
            method: 'wallet_invokeSnap',
            params: {
                request,
                snapId
            }
        });
    });
}
function sign(method, payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield sendSnapMethod({
            method,
            params: {
                payload
            }
        }, this.snapId));
    });
}
function signPayloadJSON(payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield sign.bind(this)('signPayloadJSON', payload)).signature;
    });
}
exports.signPayloadJSON = signPayloadJSON;
function signPayloadRaw(payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield sign.bind(this)('signPayloadRaw', payload)).signature;
    });
}
exports.signPayloadRaw = signPayloadRaw;
function getBalance() {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield sendSnapMethod({ method: 'getBalance' }, this.snapId));
    });
}
exports.getBalance = getBalance;
function getAddress() {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield sendSnapMethod({ method: 'getAddress' }, this.snapId));
    });
}
exports.getAddress = getAddress;
function getPublicKey() {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield sendSnapMethod({ method: 'getPublicKey' }, this.snapId));
    });
}
exports.getPublicKey = getPublicKey;
function exportSeed() {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield sendSnapMethod({ method: 'exportSeed' }, this.snapId));
    });
}
exports.exportSeed = exportSeed;
function setConfiguration(config) {
    return __awaiter(this, void 0, void 0, function* () {
        yield sendSnapMethod({ method: 'configure', params: { configuration: config } }, this.snapId);
    });
}
exports.setConfiguration = setConfiguration;
function getLatestBlock() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return (yield sendSnapMethod({ method: 'getBlock', params: { blockTag: 'latest' } }, this.snapId));
        }
        catch (e) {
            console.log('Unable to fetch latest block', e);
            return { hash: '', number: '' };
        }
    });
}
exports.getLatestBlock = getLatestBlock;
function getAllTransactions() {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield sendSnapMethod({ method: 'getAllTransactions' }, this.snapId));
    });
}
exports.getAllTransactions = getAllTransactions;
function sendSignedData(signature, txPayload) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield sendSnapMethod({
            method: 'send',
            params: {
                signature,
                txPayload
            }
        }, this.snapId);
        return response;
    });
}
exports.sendSignedData = sendSignedData;
function generateTransactionPayload(amount, to) {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield sendSnapMethod({ method: 'generateTransactionPayload', params: { amount, to } }, this.snapId));
    });
}
exports.generateTransactionPayload = generateTransactionPayload;
//# sourceMappingURL=data:application/json;base64,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